export enum AmsEndpoints {
    client          = 'client',
    amenities       = 'amenities',
    group           = 'group',
    groups          = 'groups'
}

export enum AmsRequestType {
    public          = 'public',
    private         = 'private'
}
